import React, { Component } from 'react';
import 'moment-timezone';
import 'moment/locale/es';
import { Col, Row, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import 'src/css/phone/phone.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignalRService from "src/controllers/SignalRService";
import { changeJanusStatus, setJanusDTMF } from 'src/redux/parametersSlice';
import { useNavigate } from "react-router-dom";
import Query from './query';
import Transfer from './transfer';
import Talking from './talking';
import Ringing from './ringing';
import Options from './options';
import Display from './display';
import Toastr from '../utils/toastr';
import Webphony from 'src/janus/webphony';
import WebRTC from 'src/webrtc/webrtc';
import Categories from './categories';
import { createPopper } from '@popperjs/core';
class Phone extends Component {

    constructor(props) {
        super();

        this.state = {
            dial: "",
            dialCounter: 0,
            showKeys: true,
            phoneStatus: null,
            previousPhoneStatus: null,
            mute: false,
            groupId: -1,
            groups: [],
            lastGroupsUpdate: new Date(0),
            showQuery: false,
            showTransfer: false,
            autoAnswer: false,
            showPhone: false,
            showOptions: false,
            videoTrack: false,
            showCategories: false
        };

        this.setDial = this.setDial.bind(this);
        this.handlePhoneKey = this.handlePhoneKey.bind(this);
        this.deleteKey = this.deleteKey.bind(this);
        this.makeCall = this.makeCall.bind(this);
        this.setInboundCall = this.setInboundCall.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.toggleKeys = this.toggleKeys.bind(this);
        this.setPhoneStatus = this.setPhoneStatus.bind(this);

        this.answer = this.answer.bind(this);
        this.hangup = this.hangup.bind(this);
        this.redirect = this.redirect.bind(this);
        this.toggleAutoAnswer = this.toggleAutoAnswer.bind(this);
        this.togglePhone = this.togglePhone.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
        this.toggleCategories = this.toggleCategories.bind(this);
        this.handleMessage = this.handleMessage.bind(this);

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setVideoTrack = this.setVideoTrack.bind(this);

        SignalRService.registerCTIEvent(this.setPhoneStatus);
        SignalRService.registerGroupListEvent(this.setGroupList);
        SignalRService.registerJanusInboundCall(this.setInboundCall);

        this.inputRef = React.createRef();
        this.toastrRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.showPhoneBtnRef = React.createRef();

        this.optWrapperRef = React.createRef();
        this.showOptBtnRef = React.createRef();
        this.popperInstance = React.createRef(null);

        this.minimizedRef = React.createRef();
        this.popperMin = React.createRef(null);
    }

    componentDidUpdate(prevProps, prevState) {

        let loggedIn = localStorage.getItem("fc-logged");
        if (loggedIn) {

            let diff = Date.now() - this.state.lastGroupsUpdate;

            if (this.props.functions && this.props.functions.groupCalls && diff > 10000) {

                SignalRService.getGroups({
                    "extension": this.props.extension,
                    "userId": this.props.userId
                });
            }

            if (this.inputRef.current && this.state.showPhone && this.state.showKeys)
                this.inputRef.current.focus();

            if (this.props.functions && this.props.functions.webRTC && WebRTC.socket == null) {
                WebRTC.startSocket(this.props.extension, this.props.userId);
            }

            if (this.state.showPhone) {

                this.popperInstance.current = createPopper(this.showPhoneBtnRef.current, this.wrapperRef.current, {
                    placement: 'auto',
                    modifiers: [{
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    }, {
                        name: 'preventOverflow',
                        options: {
                            padding: 8,
                        },
                    }]
                });
            } else {
                if (this.popperInstance.current) {
                    this.popperInstance.current.destroy();
                    this.popperInstance.current = null;
                }
            }


            if (!this.state.showPhone && this.state.phoneStatus && this.state.phoneStatus.ctiStatus
                && ["TALKING", "HELD", "DIALING", "BUSY", "RINGING"].indexOf(this.state.phoneStatus.ctiStatus) > -1) {

                this.popperMin.current = createPopper(this.showPhoneBtnRef.current, this.minimizedRef.current, {
                    placement: 'auto',
                    modifiers: [{
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    }, {
                        name: 'preventOverflow',
                        options: {
                            padding: 8,
                        },
                    }],
                });
            } else {
                if (this.popperMin.current) {
                    this.popperMin.current.destroy();
                    this.popperMin.current = null;
                }
            }

        }
    }

    componentDidMount() {

        document.addEventListener("mouseup", this.handleClickOutside);
        navigator.serviceWorker.addEventListener('message', this.handleMessage);

        WebRTC.setVideoTrack(this.setVideoTrack)
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.handleClickOutside);
        navigator.serviceWorker.removeEventListener("message", this.handleMessage);
    }

    handleMessage(e) {
        console.log("handleMessage:");

        if (e?.data?.action === "answer" || e?.detail?.action === "answer") {
            SignalRService.answer({
                "extension": this.props.extension,
                "userId": this.props.userId
            });

            if (this.props.phoneStatus.isWebRTC)
                WebRTC.connect();
        }

        if (e?.data?.action === "hangup" || e?.detail?.action === "hangup") {
            SignalRService.hangup({
                "extension": this.props.extension,
                "userId": this.props.userId
            });
            if (this.props.phoneStatus.isWebRTC)
                WebRTC.hangup();
        }
    }

    handleClickOutside(e) {
        if (this.state.showPhone && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.showPhoneBtnRef.current.contains(e.target)) {
            this.togglePhone();
        }

        if (this.state.showOptions && this.optWrapperRef && !this.optWrapperRef.current.contains(e.target) && !this.showOptBtnRef.current.contains(e.target)) {
            this.toggleOptions();
        }

    }

    answer = (e) => {
        e.preventDefault();
        SignalRService.answer({
            "extension": this.props.extension,
            "userId": this.props.userId
        });

        if (this.props.phoneStatus.isWebRTC)
            WebRTC.connect();
    }

    hangup = (e) => {
        e.preventDefault();

        SignalRService.hangup({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
        if (this.props.phoneStatus.isWebRTC)
            WebRTC.hangup();
    }

    redirect = (e) => {
        e.preventDefault();

        SignalRService.redirect({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "called": this.props.phoneStatus
        });
    }

    setGroupList = (groupList) => {

        if (groupList != null && groupList.length > 0) {

            let groups = [{ groupId: -1, name: this.props.t("none") }];

            groupList.forEach(element => {
                groups.push(element);
            });

            this.setState({
                groups: groups,
                lastGroupsUpdate: new Date()
            });
        }
    }

    setPhoneStatus = (status) => {
        console.log("CTI event: ", status);

        let previousPhoneStatus = this.state.phoneStatus;
        let currentPhoneStatus = { ...status };// Create a copy of status to avoid modifying the original object

        if (currentPhoneStatus.remote !== null && currentPhoneStatus.remote.trim() !== "" && previousPhoneStatus !== null && previousPhoneStatus.remote !== currentPhoneStatus.remote) {
            this.props.changeJanusStatus("makeCall");
            SignalRService.makeCall({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "called": currentPhoneStatus.remote
            });
        }

        // else {

        //     if (this.props.janusStatus === "makeCall") {
        //         this.props.changeJanusStatus("");
        //     }
        // }

        // if (currentPhoneStatus.ctiStatus === "HUNGUP") {
        //     this.props.changeJanusStatus("");
        // }

        if (["TALKING", "HELD", "DIALING", "BUSY", "RINGING"].indexOf(currentPhoneStatus.ctiStatus) > -1) {
            var then = new Date();
            then.setSeconds(then.getSeconds() - currentPhoneStatus.time);
            currentPhoneStatus = { ...currentPhoneStatus, then: then };
            if (previousPhoneStatus !== null && currentPhoneStatus.activeCallGUID === previousPhoneStatus.heldCallGUID)
                currentPhoneStatus = { ...currentPhoneStatus, then: previousPhoneStatus.then };
        }

        if ("RINGING" === currentPhoneStatus.ctiStatus && (this.state.autoAnswer || (this.props.functions?.autoAnswer && !this.props.functions?.agentAutoAnswer))) {
            let timeout = 2000;
            if (this.props?.functions?.autoAnswerTimer)
                timeout = this.props?.functions?.autoAnswerTimer * 1000;

            setTimeout(() => {
                SignalRService.answer({
                    "extension": this.props.extension,
                    "userId": this.props.userId
                });
            }, timeout);
        }

        if ("NOTLICENSE" === currentPhoneStatus.ctiStatus) {
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("notlicense"));
            this.toastrRef.current.show();
        }

        this.setState({
            previousPhoneStatus: previousPhoneStatus,
            phoneStatus: currentPhoneStatus,
            showKeys: ["HUNGUP", "MONITORED", "CONNECTED"].indexOf(currentPhoneStatus.ctiStatus) > -1,
            showPhone: this.state.showPhone || "RINGING" === currentPhoneStatus.ctiStatus,
            dial: "HUNGUP" === currentPhoneStatus.ctiStatus ? "" : this.state.dial
        });
    }

    makeCall = (e) => {
        e.preventDefault();

        if (this.state.dial !== null && this.state.dial.trim() !== "" && this.state.dial.trim() !== this.props.extension) {
            if (this.state.groupId === -1 && !this.props.functions.autoGroupCalls) {
                this.props.changeJanusStatus("makeCall");
                SignalRService.makeCall({
                    "extension": this.props.extension,
                    "userId": this.props.userId,
                    "called": this.state.dial
                });

            } else {
                this.props.changeJanusStatus("makeCall");
                SignalRService.makeCallGroup({
                    "extension": this.props.extension,
                    "userId": this.props.userId,
                    "called": this.state.dial,
                    "groupId": this.props.functions.autoGroupCalls || this.state.groupId
                });
            }

            this.setState({
                dial: ""
            });
        } else {
            let dialCounter = this.state.dialCounter;
            dialCounter += 1;

            if (dialCounter > 3) {
                dialCounter = 0;
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage("Layer 8");
                this.toastrRef.current.show();
            }

            this.setState({
                dialCounter: dialCounter
            });
        }
    }

    setDial(e) {
        e.preventDefault();
        this.setState({
            dial: e.target.value
        });

        if ("TALKING" === this.state.phoneStatus.ctiStatus && this.props.functions.janus) {

            this.props.setJanusDTMF(e.target.value.slice(-1));
        }
    }

    handlePhoneKey(value) {

        this.setState({
            dial: this.state.dial + value
        });

        if ("TALKING" === this.state.phoneStatus.ctiStatus && this.props.functions.janus) {

            this.props.setJanusDTMF(value);
        }
    }

    deleteKey(e) {
        e.preventDefault();

        this.setState({
            dial: this.state.dial.slice(0, -1)
        });
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            this.makeCall(e);
        }
    }

    toggleKeys() {
        this.setState({
            showKeys: !this.state.showKeys
        });
    }

    changeGroup = e => {
        this.setState({
            groupId: parseInt(e.target.value)
        });
    }

    toggleQuery = e => {
        //e.preventDefault();
        this.setState({ showQuery: !this.state.showQuery, showOptions: false, showPhone: true });
    }

    toggleTransfer = e => {
        this.setState({ showTransfer: !this.state.showTransfer, showOptions: false, showPhone: true });
    }

    toggleAutoAnswer = e => {
        //e.preventDefault();
        this.setState({ autoAnswer: !this.state.autoAnswer });
    }

    togglePhone = e => {
        //e.preventDefault();
        this.setState({ showPhone: !this.state.showPhone });
    }

    toggleOptions = e => {
        //e.preventDefault();
        this.setState({ showOptions: !this.state.showOptions });
    }

    setVideoTrack(value) {
        this.setState({
            videoTrack: value
        });
    }

    setInboundCall = (data) => {
        this.props.changeJanusStatus("inboundCall");
    }

    toggleCategories = e => {
        this.setState({ showCategories: !this.state.showCategories });
    }

    render() {
        return (
            (this.state.phoneStatus !== null && "NOTLICENSE" !== this.state.phoneStatus.ctiStatus) &&
            <>
                {
                    (this.state.showPhone) &&
                    <div ref={this.wrapperRef} style={{ backgroundColor: this.props.groupColor || "" }} className={"py-4 fs-6 w-325px show phone" + (this.props.phoneStatus.isWebRTC && this.state.videoTrack ? " videotrack" : "")}>
                        <div className='phoneoptions'>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("moreoptions")}
                                </Tooltip>}>
                                <Button variant='' ref={this.showOptBtnRef} className='float-start' onClick={this.toggleOptions}><FontAwesomeIcon icon={solid('ellipsis-vertical')} /></Button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("minimize")}
                                </Tooltip>}>
                                <Button variant='' onClick={this.togglePhone} className='float-end'><FontAwesomeIcon icon={solid('angle-down')} /></Button>
                            </OverlayTrigger>
                        </div>
                        {
                            (this.state.showOptions) &&
                            <Options optWrapperRef={this.optWrapperRef} key={"phoneoptions"} toggleQuery={this.toggleQuery} toggleAutoAnswer={this.toggleAutoAnswer} autoAnswer={this.state.autoAnswer}></Options>
                        }
                        {
                            (this.state.showKeys) &&
                            <div>
                                <Row>
                                    <Col>
                                        <Form>
                                            <Form.Group className="mb-4" controlId="phoneinput" >
                                                <Form.Control ref={this.inputRef} className='phoneinput' type="text" value={this.state.dial} onChange={this.setDial} onKeyDown={this.onKeyDown} />
                                            </Form.Group>
                                            {
                                                (this.state.groups && this.state.groups.length > 0 && !this.props.functions.autoGroupCalls) &&
                                                <Form.Group className="mb-4 callgroup" controlId="callgroup">
                                                    <Form.Select onChange={this.changeGroup} value={this.state.groupId}>
                                                        {
                                                            this.state.groups.map(elem => {
                                                                return <option key={elem.groupId} value={elem.groupId}>{elem.name}</option>
                                                            })
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            }
                                        </Form>
                                    </Col>
                                </Row>
                                <div className='keys'>
                                    <Row>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("1")}>1</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("2")}>2</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("3")}>3</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("4")}>4</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("5")}>5</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("6")}>6</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("7")}>7</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("8")}>8</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("9")}>9</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("*")}><FontAwesomeIcon icon={duotone('asterisk')} /></button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("0")}>0</button></Col>
                                        <Col><button className='phonekey' onClick={() => this.handlePhoneKey("#")}><FontAwesomeIcon icon={duotone('hashtag')} /></button></Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {
                                                (["TALKING", "HELD", "DIALING", "BUSY"].indexOf(this.state.phoneStatus.ctiStatus) > -1) &&
                                                <OverlayTrigger
                                                    placement="left"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                                        {this.props.t("back")}
                                                    </Tooltip>}>
                                                    <button className='phonekey' onClick={this.toggleKeys}><FontAwesomeIcon icon={duotone('keyboard-left')} /></button>
                                                </OverlayTrigger>
                                            }
                                        </Col>
                                        <Col>
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("call")}
                                                </Tooltip>}>
                                                <button className='makecall' onClick={this.makeCall}><FontAwesomeIcon size='3x' icon={solid('phone')} /></button>
                                            </OverlayTrigger>
                                        </Col>
                                        <Col>
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("delete")}
                                                </Tooltip>}>
                                                <button className='phonekey' onClick={this.deleteKey}><FontAwesomeIcon icon={duotone('delete-left')} /></button>
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        }
                        {
                            (["TALKING", "HELD", "DIALING", "BUSY"].indexOf(this.state.phoneStatus.ctiStatus) > -1 && !this.state.showKeys) &&
                            <Talking key={"phonetalking"} phoneStatus={this.state.phoneStatus} toggleTransfer={this.toggleTransfer}
                                answer={this.answer} hangup={this.hangup} toggleKeys={this.toggleKeys} toggleQuery={this.toggleQuery}
                                toggleAutoAnswer={this.toggleAutoAnswer} autoAnswer={this.state.autoAnswer} toggleCategories={this.toggleCategories}
                            ></Talking>
                        }
                        {
                            (["RINGING"].indexOf(this.state.phoneStatus.ctiStatus) > -1) &&
                            <Ringing key={"phoneringing"} phoneStatus={this.state.phoneStatus} answer={this.answer} hangup={this.hangup} toggleTransfer={this.toggleTransfer} ></Ringing>
                        }
                    </div>
                }
                {
                    (!this.state.showPhone && ["TALKING", "HELD", "DIALING", "BUSY", "RINGING"].indexOf(this.state.phoneStatus.ctiStatus) > -1) &&
                    <div className='minimizedphone' ref={this.minimizedRef} style={{ backgroundColor: this.props.groupColor || "" }}>
                        <Display phoneStatus={this.state.phoneStatus} showPhone={false}></Display>
                    </div>
                }
                {
                    (this.props.form !== null && this.props.form.trim() !== "") &&
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("formopened")}
                        </Tooltip>}>
                        <div className='formbutton' onClick={this.props.toggleForm} style={{ backgroundColor: ((["TALKING", "HELD", "DIALING", "BUSY", "RINGING"].indexOf(this.state.phoneStatus.ctiStatus) > -1) ? "#009ef7" : "#f1416c") }}>
                            <FontAwesomeIcon size='2x' icon={duotone("file-invoice")} />
                        </div>
                    </OverlayTrigger>
                }
                {
                    (this.props.form === "" && this.state.phoneStatus.activeCallGUID !== null && this.props.contacts !== null && this.props.contacts.length > 0) &&
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("contact")}
                        </Tooltip>}>
                        <div className='formbutton' onClick={this.props.toggleBook} style={{ backgroundColor: ((["TALKING", "HELD", "DIALING", "BUSY", "RINGING"].indexOf(this.state.phoneStatus.ctiStatus) > -1) ? "#009ef7" : "#f1416c") }}>
                            <FontAwesomeIcon size='2x' icon={duotone("address-book")} />
                        </div>
                    </OverlayTrigger>
                }
                <Query show={this.state.showQuery} toggleModal={this.toggleQuery} togglePhone={this.togglePhone}></Query>
                <Transfer show={this.state.showTransfer} toggleModal={this.toggleTransfer} togglePhone={this.togglePhone}></Transfer>
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("phone")}
                    </Tooltip>}>
                    <div ref={this.showPhoneBtnRef} className='phoneicon' onClick={this.togglePhone} style={{ backgroundColor: this.props.groupColor || "" }}>
                        <FontAwesomeIcon size='3x' icon={faPhone} />
                    </div>
                </OverlayTrigger>
                <Toastr ref={this.toastrRef} />
                {
                    (this.props.janusPrivate || this.props.janusPublic) &&
                    <Webphony></Webphony>
                }
                <Categories show={this.state.showCategories} toggleModal={this.toggleCategories} extension={this.props.extension} userId={this.props.userId}></Categories>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        phoneStatus: state.agent.phoneStatus,
        previousPhoneStatus: state.agent.previousPhoneStatus,
        functions: state.agent.functions,
        callForm: state.agent.callForm,
        selectedForm: state.agent.selectedForm,
        janusPrivate: state.parameters.janusPrivate,
        janusPublic: state.parameters.janusPublic,
        contacts: state.agent.contacts,
        groupColor: state.agent.groupColor,
        janusStatus: state.parameters.janusStatus
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Phone {...props} navigate={navigate} />
}

export default compose(connect(mapStateToProps, { changeJanusStatus, setJanusDTMF }), withTranslation())(WithNavigate);